import * as materialColors from '@material-ui/core/colors';
import { Colors } from './colors.types';

const colors: Colors<any, any> = {
  ...materialColors
};

export default colors;
